import { logEvent } from 'AppManager';
import { t } from 'Locale';
import { ActivityIndicator, Hr, Icon, ModalHeader } from 'LocalGluons';
import { useChromecastContext } from 'LocalGluons/components/ChromecastContext';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { CastChannel, CastState, useDevices } from 'react-native-google-cast';
import Theme from 'Theme';
import styles from './ChromecastModal.jss';

// const CastState = Platform.select({
//     android: () => require('react-native-google-cast').CastState,
//     default: () => { },
// })();

interface ChromecastModalProps {
    switchFromLowLatency: () => void;
    onClose: () => void;
    continueWatchingChannel: CastChannel | null
}

export const ChromecastModal = ({ onClose, continueWatchingChannel }: ChromecastModalProps) => {
    const { castDevice, castState, sessionManager, activeDevice, setChromecast } = useChromecastContext();
    const devices = useDevices();
    // to deduplicate devices; error that happens on some samsung devices
    // const uniqueDevices = new Set(devices);

    return (
        <View style={styles.container}>
            <ModalHeader style={styles.header}
                onPress={onClose}
            />
            <View style={styles.main}>
                <Text style={styles.title}>{t('SS.CHROMECAST.CAST_TO_DEVICE.TITLE')}</Text>
                <Hr style={styles.hr} />
                <ScrollView style={styles.list} contentContainerStyle={styles.contentList}>
                    {devices.map((device) => {
                        const active = device.deviceId === castDevice?.deviceId;
                        const isConnecting = castState === CastState['CONNECTING'] && activeDevice.current?.deviceId === device.deviceId;
                        return (
                            <TouchableOpacity
                                key={device.deviceId}
                                style={styles.button}
                                disabled={isConnecting}
                                onPress={() => {
                                    if (active) {
                                        activeDevice.current = null;
                                        if (continueWatchingChannel)
                                            continueWatchingChannel.sendMessage(JSON.stringify({
                                                message: 'THE LAST RECEIVER MEDIA TIME',
                                                state: true
                                            }));
                                        // if receiver did't send back a message with time
                                        setTimeout(() => {
                                            if (!activeDevice.current && castDevice) {
                                                logEvent({
                                                    type: 'user-flow',
                                                    subtype: 'player-cast',
                                                    content1: 'stop',
                                                    content2: castDevice.friendlyName,
                                                    context: '/player'
                                                });
                                                sessionManager?.endCurrentSession();
                                            }
                                        }, 3000);
                                    } else {
                                        activeDevice.current = device;
                                        logEvent({
                                            type: 'user-flow',
                                            subtype: 'player-cast',
                                            content1: 'start',
                                            content2: device.friendlyName,
                                            context: '/player'
                                        });
                                        sessionManager?.startSession(device.deviceId);
                                        setChromecast((oldChromecast) => ({
                                            ...oldChromecast,
                                            mediaInfo: {
                                                ...oldChromecast.mediaInfo,
                                                customData: {
                                                    ...oldChromecast.mediaInfo.customData,
                                                    modelName: device.modelName
                                                }
                                            }
                                        }));
                                    }
                                }}
                                testID="subtitles_button"
                            >
                                <Icon
                                    name={active ? 'tv_on' : 'tv'}
                                    style={styles.icon}
                                    key="tv"
                                    testID="tv_icon"
                                />
                                <View style={styles.buttonLabelContainer}>
                                    <Text
                                        style={{
                                            ...styles.buttonLabel, color: active
                                                ? Theme.primaryActiveColor
                                                : Theme.primaryTextColor
                                        }}
                                        numberOfLines={1}>
                                        {device.friendlyName}
                                    </Text>
                                </View>
                                {isConnecting && <ActivityIndicator size='small' style={styles.icon} color="#fff" />}
                            </TouchableOpacity>
                        );
                    })}
                </ScrollView>
            </View>
        </View>
    );
};

export default ChromecastModal;